import styled from 'styled-components'

import theme from '../../theme'

const CollapseContainer = styled.div`
  .ant-collapse-item-active {
    box-shadow: 0px 10px 15px rgba(0, 0, 0, 0.08), 0px 4px 6px rgba(0, 0, 0, 0.03);
  }
  .ant-collapse-item {
    border: 0px;
    &:hover {
      box-shadow: 0px 10px 15px rgba(0, 0, 0, 0.08), 0px 4px 6px rgba(0, 0, 0, 0.03);
    }
  }
  .ant-collapse-content {
    border-top: 0px;
  }
  .ant-collapse {
    border: 1px solid ${theme.colors.gray4};
  }

  .collapsable-card {
    background: ${theme.colors.white};
    border-radius: 4px;
  }
`

export { CollapseContainer }
